import TabBar from '../../component/tab-bar/tab-bar';
import Breadcrumb from '../../component/breadcrumb/breadcrumb';
import DataTableContainer from '../../component/data-table-container/data-table-container';
import React, { useState } from 'react';
import { CelType, Table } from '../../component/data-table/data-table';
import generateRowHeader from '../../component/data-table-container/utils/generate-row-header';

const tabs = ['סטודנטים'];

function createTableData(data: string[][]): Table {
  return {
    rowHeader: generateRowHeader([
      'מס״ד',
      'שם',
      'שם משפחה',
      'מייל',
      'טלפון',
      'תאריך לידה',
    ]),
    rows: data.map((row) => ({
      cells: row.map((content) => ({
        content: content,
        type: CelType.REGULAR,
      })),
    })),
  };
}

const studentsDatamodelMock = [
  ['1', 'דויד', 'רבינוביץ', 'davidRa@gmail.com', '052-6784344', '14.9.1996'],
  ['1', 'דויד', 'רבינוביץ', 'davidRa@gmail.com', '052-6784344', '14.9.1996'],
  ['1', 'דויד', 'רבינוביץ', 'davidRa@gmail.com', '052-6784344', '14.9.1996'],
  ['1', 'דויד', 'רבינוביץ', 'davidRa@gmail.com', '052-6784344', '14.9.1996'],
  ['1', 'דויד', 'רבינוביץ', 'davidRa@gmail.com', '052-6784344', '14.9.1996'],
  ['1', 'דויד', 'רבינוביץ', 'davidRa@gmail.com', '052-6784344', '14.9.1996'],
  ['1', 'דויד', 'רבינוביץ', 'davidRa@gmail.com', '052-6784344', '14.9.1996'],
];

const StudentsPage = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const onTabSelected = (index: number) => {
    setSelectedIndex(index);
  };

  return (
    <div className={'studies-settings-root'}>
      <div className={'studies-settings-body-page'}>
        <div className={'studies-settings-title'}>סטודנטים</div>

        <TabBar
          tabs={tabs}
          onClick={(index) => {
            onTabSelected(index);
            console.log('The index ' + index + 'Is clicked');
          }}
        ></TabBar>
        {/*        <br />
        <br />
        <Breadcrumb
          onClick={(index) => {
            console.log('a');
          }}
          crumbs={['משתמשים', 'סטודנטים']}
        ></Breadcrumb>
        <br />*/}
        <DataTableContainer
          title={tabs[selectedIndex]}
          isLoading={isLoading}
          lazyLoading={{
            columnNumber: studentsDatamodelMock[0].length,
            rowsNumber: 10,
          }}
          table={createTableData(studentsDatamodelMock)}
        />
      </div>
    </div>
  );
};

export default StudentsPage;
